import { adminLogout } from "../../../redux/actions/adminActions";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
// import { laundroRedirectUrl, laundroText } from "../../../dynamicController";

const Topbar = ({ handleToggle, logout }) => {
	const history = useHistory();
	return (
		<nav className="navbar">
			<div>
				<button onClick={() => handleToggle()}>
					<i style={{ fontSize: "20px" }} className="fas fa-bars"></i>
				</button>
			</div>
			<div className="dropdown">
				<button type="button" className="dropdown-toggle" id="dropdownMenu" data-bs-toggle="dropdown" aria-expanded="false">
					<i style={{ fontSize: "40px" }} className="fas fa-user-circle"></i>
				</button>
				<div style={{ transform: "translate(-100px, 0px)" }} className="dropdown-menu m-0" aria-labelledby="dropdownMenu">
					<div className="dropdown-item">
						<button
							onClick={() => {
								logout();
								history.push("/admin/login");
							}}
							className="btn"
						>
							Logout
						</button>
					</div>
					{/* <a href={laundroRedirectUrl()} className="dropdown-item py-3" style={{ color: "black" }}>
						Back To {laundroText()}
					</a> */}
				</div>
			</div>
		</nav>
	);
};

const mapDispatchToProps = dispatch => {
	return {
		logout: () => dispatch(adminLogout())
	};
};

export default connect(null, mapDispatchToProps)(Topbar);
